(function() {
    var module;

    try {
        // Get current templates module
        module = angular.module('templates');
    } catch (error) {
        // Or create a new one
        module = angular.module('templates', []);
    }

    module.run(["$templateCache", function($templateCache) {
        $templateCache.put('player/message.html', '<div class=\"mobile-step mobile-step--msg\">\n	<div class=\"step_header\">\n		<button class=\"btn btn--pin\" ng-click=\"stop()\"><span>{{quizid}}</span></button>\n		<h2 class=\"step_header_title\">{{ screen.title }}</h2>\n\n	</div>\n	<div class=\"step_content\" ng-hide=\"screen.subtype === \'results\'\">\n		<img class=\"step_icon\" ng-if=\"screen.icon\" ng-src=\"{{baseurl}}/images/mobile/{{screen.icon}}.svg\" />\n		<p>{{ screen.message }}</p>\n	</div>\n	<div class=\"step_content\" ng-show=\"screen.subtype === \'results\'\">\n		<img class=\"step_icon\" ng-if=\"screen.icon\" ng-src=\"{{baseurl}}/images/mobile/attention.svg\" />\n		<h2 ng-if=\"resultFeedbackTitle\">{{ resultFeedbackTitle }}</h2>\n		<h3 ng-if=\"resultFeedbackExplanation\">\n			{{resultFeedbackExplanation}}\n		</h3>\n	</div>\n\n</div>\n');
    }]);
})();